import { useAuth } from '../contexts/AuthContext';
import { isVideoLive } from '../utils/mediaUploadSpecs';

/**
 * Whether this viewer can upload and see video (VIDEO_PLAN, shipped dark):
 * everyone once VIDEO_STATUS is 'live' (src/config/videoLimits.js), admins
 * before. The server's own gate (videoUploadService.canUse) is the real
 * check — every video route answers 404 otherwise — so this only decides
 * whether to offer the UI.
 */
export default function useVideoEnabled() {
  const { isAdmin } = useAuth();
  return isVideoLive() || !!isAdmin;
}
